import Payment from '@pages/partners-order/payment-shipping/Payment';
import Shipping from '@pages/partners-order/payment-shipping/Shipping';
import { Dispatch } from '@pages/partners-order/payment-shipping/Dispatch';



const PaymentShipping = () => {

	return (
		<div className='payment-shipping-section'>

			<Payment />
			
			<Shipping />

			<Dispatch />

		</div>
	);
};

export default PaymentShipping;